

// utils function
function addQueryParam(url, param, value) {
  const urlObject = new URL(url);
  urlObject.searchParams.set(param, value);
  return urlObject.toString();
}
function showError(id, message, status = true , className = '') {
  const errorElement = document.getElementById(id);
  if (errorElement ) {
    if (status) {
      errorElement.innerHTML = message;
      errorElement.style.display = 'block';
      if(className !== ''){
        errorElement.classList.add(className);
      }
    }else{
      errorElement.style.display = 'none';
    }  
  }
}
function showLoader(status, target='') {
  if (status) {
    var loadingOverlay = document.createElement("div")
    loadingOverlay.classList.add("loding-overlay")
    if (target=='') {
      document.body.append(loadingOverlay)
    }else{
      target.append(loadingOverlay)
    }
    
  }else{
    if (target=='') {
      if(document.querySelector(".loding-overlay")) document.querySelector(".loding-overlay").remove();
    }else{
      if(target.querySelector(".loding-overlay")) target.querySelector(".loding-overlay").remove();
    }
    
  }

}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => video.pause());
}
// Media control start (Pasuse playing exting video on document)
if(document.getElementById("cover_image__video_section")){
   var playBtn=document.getElementById("play_btn__video_section");
   var videoIframe=document.getElementById("video_iframe__video_section");
   var coverImage=document.getElementById("cover_image__video_section");
   playBtn.addEventListener("click",()=>{
     if(videoIframe.closest('.hidden')){
       coverImage.classList.add("hidden");
       videoIframe.classList.remove("hidden");
     }else{
       videoIframe.classList.add("hidden");
       coverImage.classList.remove("hidden");
     }
   })
}
function cartRender(cartId){
  const cartElement = document.getElementById(cartId);
  if (cartElement) {
    const cartRenderURL = cartElement.getAttribute('data-render');
    fetch(cartRenderURL)
    .then((response) => response.text())
    .then((responseText) => {
      const html = new DOMParser().parseFromString(responseText, 'text/html');
      const destination = document.getElementById(cartId);
      const source = html.getElementById(cartId);
      if (source && destination) {
        destination.innerHTML = '';
        destination.innerHTML = source.innerHTML;
        var cart_count = source.getAttribute('data-count');
        document.querySelectorAll('.cart_icon_on_header').forEach((cart_icons) => {
          if (Number(cart_count) == 0) {
            cart_icons.classList.add('hidden');
          } else {
            cart_icons.classList.remove('hidden');
          }
        });
      }
      document.querySelectorAll('.cart-count__header').forEach((cartCountElem) =>{
        cartCountElem.innerHTML = `(${cart_count})`;
      })
      showLoader(false);
    });
  }

}

// Slideshow Component
function handelPrevNextThumb(productScrollThumbContainer) {
  var scrollLeft = productScrollThumbContainer.scrollLeft;
  var maxScrollLeft =
    productScrollThumbContainer.scrollWidth -
    productScrollThumbContainer.clientWidth - 10;
  var nextSlide =
    productScrollThumbContainer.parentElement.querySelector("next-slide");
  var previousSlide =
    productScrollThumbContainer.parentElement.querySelector("previous-slide");
  if (scrollLeft > 0 ) {
    if (previousSlide) {
      previousSlide.classList.add("show");
      nextSlide.classList.remove("show");
    }
  }
  if (scrollLeft < maxScrollLeft) {
    if (nextSlide) {
      nextSlide.classList.add("show");
      previousSlide.classList.remove("show");
    }
  }
 
}
class PreviousIcon extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", () => {
      const thumbClass = this.dataset.thumb;
      const sliderContent = document.querySelector(`.${thumbClass}`);      
      sliderContent.scrollTo({
        left: 0,
        behavior: "smooth",
      });

      sliderContent.addEventListener("scroll", () => {
        handelPrevNextThumb(sliderContent);
      });
    });
  }
}



class NextIcon extends HTMLElement {
  connectedCallback() {
    this.addEventListener("click", () => {
      const thumbClass = this.dataset.thumb;
      const sliderContent = document.querySelector(`.${thumbClass}`);
      const maxScrollLeft =
        sliderContent.scrollWidth - sliderContent.clientWidth;
      const scrollAmount = sliderContent.clientWidth;
      sliderContent.scrollTo({
        left: sliderContent.scrollLeft + scrollAmount,
        behavior: "smooth",
      });
      sliderContent.addEventListener("scroll", () => {
        handelPrevNextThumb(sliderContent);
      });
    });
  }
}


window.customElements.define("previous-slide", PreviousIcon);
window.customElements.define("next-slide", NextIcon);
class PrevNextNavigation extends HTMLElement {
  connectedCallback() {
    const elementCls = this.getAttribute('data-thumb');
    
    const dataThumbElement = document.querySelector(`.${elementCls}`);
    if (dataThumbElement && dataThumbElement.scrollWidth > dataThumbElement.clientWidth) {
      const nextSlideElement = this.querySelector('next-slide');
      nextSlideElement.classList.add('show');
    }
  }
}

customElements.define('prev-next-navigation', PrevNextNavigation);


class SliderBox extends HTMLElement {
  constructor() {
    super();

    this.autoplay = this.getAttribute('autoplay') === 'true';
    this.autoplayDuration = parseInt(this.getAttribute('autoplay-duration')) || 4000;
    this.currentIndex = 0;
    this.imageBoxes = this.querySelectorAll('.slide_box__content');
    this.navigation_box__slides = this.querySelectorAll('.navigation_box__slide');

    this.handleClick = this.handleClick.bind(this);

    this.createSlider();
  }

  connectedCallback() {
    this.startAutoplay();
  }

  createSlider() {
    this.addEventListener('click', this.handleClick);

    this.showImage(this.navigation_box__slides[0].getAttribute('data-image-id'));
  }

  handleClick(event) {
    const navigation_box__slide = event.target.closest('.navigation_box__slide');
    //console.log(event.target)
    if (navigation_box__slide) {
      const imageId = navigation_box__slide.getAttribute('data-image-id');
      this.stopAutoplay();
      this.showImage(imageId);
    }
  }

  showImage(imageId) {
    this.imageBoxes.forEach((imageBox) => {
      const boxId = imageBox.getAttribute('id');
      if (boxId === imageId) {
        imageBox.classList.add('active');
      } else {
        imageBox.classList.remove('active');
      }
    });

    this.navigation_box__slides.forEach((navigation_box__slide) => {
      const navigation_box__slideId = navigation_box__slide.getAttribute('data-image-id');
      if (navigation_box__slideId === imageId) {
        navigation_box__slide.classList.add('active');
      } else {
        navigation_box__slide.classList.remove('active');
      }
    });
  }

  startAutoplay() {
    if (this.autoplay) {
      this.autoplayInterval = setInterval(() => {
        const nextIndex = (this.currentIndex + 1) % this.imageBoxes.length;
        const nextImageId = this.imageBoxes[nextIndex].getAttribute('id');
        this.showImage(nextImageId);
        this.currentIndex = nextIndex;
      }, this.autoplayDuration);
    }
  }

  stopAutoplay() {
    clearInterval(this.autoplayInterval);
  }
}

customElements.define('slider-box', SliderBox);

class SlideshowComponent extends HTMLElement {
  constructor() {
    super();
    this.slides = [];
    this.dots = [];
    this.timeIntervalSlideshow = parseInt(this.dataset.interval) * 1000;
    this.slideAutoplay = JSON.parse(this.dataset.autoplay);
    this.slideIndex = 0;
    this.designModeCurrent = false;
    

  }

  connectedCallback() {
    this.slides = Array.from(this.querySelectorAll('slide'));
    this.dots = Array.from(this.querySelectorAll('.slide_nav'));

    if (Shopify.designMode) {
      this.addEventListener('shopify:block:select', (event) => {
        const blockSelectedIsSlide = event.target.classList.contains('slideshow__slide');
        if (blockSelectedIsSlide) {
          this.designModeCurrent = true;
          const selectedSlide = event.target.closest('.slideshow__slide');
          if (selectedSlide) {
            for (let i = 0; i < this.slides.length; i++) {
              if (selectedSlide == this.slides[i]) {
                this.currentSlide(parseInt(this.slides[i].dataset.slideid));
              }else{
                this.slides[i].classList.remove('active_slide');
                this.dots[i].classList.remove('active-slider_nav');
              }
            }
            if (this.slideAutoplay) {
              this.slideAutoplay = false;
            }
          }
        }
      });

      this.addEventListener('shopify:block:deselect', (event) => {
        const blockDeselectedIsSlide = event.target.classList.contains('slideshow__slide');
        if (blockDeselectedIsSlide) {
          this.designModeCurrent = false;
          if (!this.slideAutoplay) {
            this.slideAutoplay = true;
            this.showSlides('');
          }
        }
      });
      if (this.slideAutoplay && !this.designModeCurrent) {
        this.showSlides('');
      }

    }else{
      if(this.slideAutoplay){
          this.showSlides('');
      }
    }
 
    this.dots.forEach((sliderDot) => {
      sliderDot.addEventListener('click', (e) => {
        this.slideAutoplay = false;
        this.currentSlide(parseInt(e.target.dataset.slideid));
      });
    });
  }

  plusSlides(n) {
    this.showSlides(this.slideIndex + n);
  }
  showSlides(n = '') {
    if (n !== '') {
      if (n > this.slides.length) {
        this.slideIndex = 1;
      } else if (n < 1) {
        this.slideIndex = this.slides.length;
      } else {
        this.slideIndex = n;
      }
    } else {
      if (this.slideAutoplay && !this.designModeCurrent) {
        this.slideIndex++;
        if (this.slideIndex > this.slides.length) {
          this.slideIndex = 1;
        }
      }
    }

    for (let i = 0; i < this.slides.length; i++) {
      this.slides[i].classList.remove('active_slide');
      this.dots[i].classList.remove('active-slider_nav');
    }

    this.slides[this.slideIndex - 1].classList.add('active_slide');
    this.dots[this.slideIndex - 1].classList.add('active-slider_nav');

    if (this.slideAutoplay && !this.designModeCurrent) {
      this.playSlideshow(true);
    }
  }

  currentSlide(n) {
    this.showSlides(n);
  }

  playSlideshow(play) {
    if (play) {
      setTimeout(() => {
        this.showSlides('');
      }, this.timeIntervalSlideshow);
    }
  }
}

customElements.define('slideshow-component', SlideshowComponent);

//  Quantity input
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.container = this.querySelector('[data-quantity]');
    this.quantity_target = this.querySelector('[data-quantity-target]');
    this.quantity_minus = this.querySelector('[data-quantity-minus]');
    this.quantity_plus = this.querySelector('[data-quantity-plus]');
    this.quantity_plus.addEventListener('click', (event) => {
      this._add();
    });
    this.quantity_minus.addEventListener('click', (event) => {
      this._minus();
    });
  }
  _add() {
    const setValuePlus = parseInt(this.quantity_target.value) + parseInt(this.quantity_target.step);
    document.querySelector(`.${this.getAttribute('data-section')}`).querySelector('add-to-cart').dataset.quantity = setValuePlus;
    this.quantity_target.value = setValuePlus;
  }
  _minus() {
    if (this.quantity_target.value > 1){
      const setValueMinus = parseInt(this.quantity_target.value) - parseInt(this.quantity_target.step);
      document.querySelector(`.${this.getAttribute('data-section')}`).querySelector('add-to-cart').dataset.quantity = setValueMinus;
      this.quantity_target.value = setValueMinus;
    }
      
  }
}
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input',QuantityInput);
}
if (!customElements.get('quantity-input-cart')) {
  customElements.define(
    'quantity-input-cart',
    class QuantityInputCart extends HTMLElement {
      constructor() {
        super();
        this.container = this.querySelector('[data-quantity]');
        this.quantity_target = this.querySelector('[data-quantity-target]');
        this.quantity_minus = this.querySelector('[data-quantity-minus]');
        this.quantity_plus = this.querySelector('[data-quantity-plus]');
        this.cartId = this.getAttribute('data-cart-id');
        this.mainCartPageId = this.getAttribute('data-main-cart-id');
        this.quantity_plus.addEventListener('click', (event) => {
          this._add();
          
        });
        this.quantity_minus.addEventListener('click', (event) => {
          this._minus();
          
        });
        this.quantity_target.addEventListener('change', (event) => {
         this._change();
        });
      }
      _change(){
        const currentValue = parseInt(this.quantity_target.value);
        this._updateCart(currentValue)
          .then(([responseStatus, responseData]) => {
            if (responseStatus === 200) {
              cartRender(this.cartId);
              if (this.mainCartPageId) {
                cartRender(this.mainCartPageId);    
              }
            }else{
              showLoader(false);
              showError(this.getAttribute('data-error-id'),responseData.message)
            }
          });
      }
      _add() {
        const currentValue = parseInt(this.quantity_target.value);
        const toSetPlusValue = currentValue + parseInt(this.quantity_target.step);
        this._updateCart(toSetPlusValue)
          .then(([responseStatus, responseData]) => {
            if (responseStatus === 200) {
              cartRender(this.cartId);
              if (this.mainCartPageId) {
                cartRender(this.mainCartPageId);    
              }
            }else{
              showLoader(false);
              showError(this.getAttribute('data-error-id'),responseData.message)
            }
          });
      }
      _minus() {
        const currentValue = parseInt(this.quantity_target.value);
        const toSetMinusValue  = currentValue - parseInt(this.quantity_target.step);
        if(toSetMinusValue > 0){
          this._updateCart(toSetMinusValue)
          .then(([responseStatus, responseData]) => {
            if (responseStatus === 200 && currentValue > 1) {
              cartRender(this.cartId);
              if (this.mainCartPageId) {
                cartRender(this.mainCartPageId);    
              }
            }else{
              showLoader(false);
              showError(this.getAttribute('data-error-id'),responseData.message)
            }
          });
        }
      }
      _updateCart(quantity) {
        showLoader(true);
        const variantId = this.getAttribute('data-variant-id');
        const url = window.routes.cart_change_url;
        const payload = {
          id: variantId,
          quantity: quantity
        };
        const options = {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(payload)
        };
        return fetch(url, options)
          .then(response => {
            return Promise.all([response.status, response.json()]);
          })
          .catch(error => {
            showLoader(false);
            return null;
          });
      }
    }
  );
}

if (!customElements.get('cart-note')) {
  customElements.define(
    'cart-note',
    class CartDrawerNote extends HTMLElement {
      constructor() {
        super();
        this.cartDrawerNote = this.querySelector('textarea[name="note"]');
        this.cartDrawerNote.addEventListener('change', (event) => {
          const cartDrawerNoteValue = event.target.value;
          this._updateCartDrawerNote(cartDrawerNoteValue);
        });
      }

      _updateCartDrawerNote(note) {
        fetch(window.routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ note }),
        })
          .then((res) => {
            // Handle response if needed
          })
          .catch((error) => {
            console.error('Error updating cart drawer note:', error);
          });
      }
    }
  );
}

if (!customElements.get('remove-cart-item')) {
  customElements.define(
    'remove-cart-item',
    class RemoveCartItem extends HTMLElement {
      constructor() {
        super();
        this.url = this.getAttribute('data-url');
        this.cartId = this.getAttribute('data-cart-id');
        this.mainCartPageId = this.getAttribute('data-main-cart-id');
        this.addEventListener('click', this._handleClick.bind(this));
      }

      _handleClick() {
        if (this.url) {
          showLoader(true);
          fetch(this.url, {
            method: 'POST'
          })
            .then((response) => {
              cartRender(this.cartId);
              cartRender(this.mainCartPageId);
            })
            .catch((error) => {
              console.error('Error removing cart item:', error);
            });
        } else {
          console.warn('URL attribute is missing for <remove-cart-item> element.');
        }
      }
    }
  );
}
// ReadMoreDescription
class ReadMoreDescription extends HTMLElement {
  constructor() {
    super();
    const maxLengthAttr = this.getAttribute('max-length');
    this.maxLength = maxLengthAttr;
    this.readMoreButton = this.querySelector('.read-more');
    this.readLessButton = this.querySelector('.read-less');
    this.productDescription = this.querySelector('.description-content');
   // console.log(maxLengthAttr , this.productDescription.offsetHeight)
    if (maxLengthAttr <= this.productDescription.offsetHeight) {  
      this.toggleContent(false, this.productDescription);
    }else if( maxLengthAttr > this.productDescription.offsetHeight){
      this.toggleContent(null, this.productDescription);
    }
  }

  connectedCallback() {

    
    this.readMoreButton.addEventListener('click', () => this.toggleContent(true, this.productDescription));
    this.readLessButton.addEventListener('click', () => this.toggleContent(false, this.productDescription));
  }


  toggleContent(showAll, contentElement) {
   
    if (showAll) {
      contentElement.style.maxHeight = 'none';
      this.readMoreButton.style.display = 'none';
      this.readLessButton.style.display = '';
    } else if(showAll == false || showAll != null) {
      contentElement.style.maxHeight = `${this.maxLength}px`; // Adjust the height as needed
      this.readMoreButton.style.display = '';
      this.readLessButton.style.display = 'none';
    }else {
      this.readMoreButton.style.display = 'none';
      this.readLessButton.style.display = 'none';
    }
  }
}

customElements.define('read-more-description', ReadMoreDescription);
/// ADD to cart component

class AddToCartComponent extends HTMLElement {
  constructor(){
    super();
    this.cartId = this.getAttribute('data-cart-id');
    this.addtoCardForm = this.getAttribute('data-form') || null;
  }
  connectedCallback() {
    this.addEventListener('click', this.handleClick);
  }

  handleClick(event) {
    event.preventDefault();
    const variant = this.getAttribute('data-variant');
    var quantity = this.getAttribute('data-quantity');
    let line = (document.querySelector(`#${this.addtoCardForm} [name="selling_plan"]`)) ? parseInt(document.querySelector(`#${this.addtoCardForm} [name="selling_plan"]`).value) : null;
    const btnContent = this.querySelector('.btn-content');
    const btnloading = this.querySelector('.btn-loading');
    let addToCartMainProductItems = {
      items: [
        {
          selling_plan: line,
          id: variant,
          quantity: quantity,
        },
      ],
    };
    
    try {
      btnContent.style.display = "none";
      btnloading.style.display = "flex";
      fetch(window.routes.cart_add_url, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(addToCartMainProductItems),
      }).then((res) => {
        btnContent.style.display = "block";
        btnloading.style.display = "none";
        showLoader(false);
        if(res.status == 200 ){
          if (this.getAttribute('data-error-id')) {
            showError(this.getAttribute('data-error-id'), '', false);
          }
          document.querySelector('quickViewModal').classList.remove('is-open')
          cartDrawerOpenClose('open');
          cartRender(this.cartId);
        }else if(res.status == 422 ){
          res.json().then((data) => {
            if (this.getAttribute('data-error-id')) {
              showError(this.getAttribute('data-error-id'),  data.description);
            }
          });
          
        }
      });
    } catch (e) {
      btnContent.style.display = "block";
      btnloading.style.display = "none";
      return true;
    }
  }
  
}

// Register the custom element
customElements.define('add-to-cart', AddToCartComponent);

class QuickViewComponent extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.closeQuickView());
    this.product_url = addQueryParam(this.dataset.url, 'section_id', 'api-quick-view') ;
    this.modalContainer = document.querySelector('.quick-view-modal-container');
    this.modalContent = document.querySelector('.quick-view-modal-content');
    this.closeBtn = document.querySelector('.quick-view-close-btn');
    this.addEventListener('click', this.openQuickView.bind(this));
    this.closeBtn.addEventListener('click', this.closeQuickView.bind(this));
    this.btnContent = this.querySelector('.btn-content');
    this.btnloading = this.querySelector('.btn-loading');
  }

  openQuickView(event) {
    event.preventDefault(); // Prevent default behavior
    this.fetchQuickViewDetails();

  }

  closeQuickView() {
    this.modalContainer.classList.remove('is-open')
    document.body.style.overflow = '';
  }

  fetchQuickViewDetails() {
    showLoader(true);
    this.btnContent.style.display = "none";
    this.btnloading.style.display = "flex";
    fetch(this.product_url)
      .then((response) => response.text())
      .then((data) => {
        this.modalContainer.classList.add('is-open')
        document.body.style.overflow = 'hidden';
        this.renderQuickView(data);
      })
      .catch((error) => {
        showLoader(false);
        this.btnContent.style.display = "block";
        this.btnloading.style.display = "none";
        console.error('Error:', error);
      });
  }

  renderQuickView(data) {
    const quickViewDetails = document.querySelector('.quick-view-details');
    const quickViewDetailsHTML = new DOMParser()
    .parseFromString(data, 'text/html')
    .querySelector('.api-quick-view-product');
    
    if (quickViewDetailsHTML) {
      quickViewDetails.innerHTML = '';
      quickViewDetails.appendChild(quickViewDetailsHTML); 
      showLoader(false);
      this.btnContent.style.display = "block";
      this.btnloading.style.display = "none";
    }
  }
}

customElements.define('quick-view', QuickViewComponent);

//VideoMedia
class VideoMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="VideoMedia-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      this.style.height = this.querySelector('[id^="VideoMedia-Poster-"]').offsetHeight + 'px';
      this.style.width = this.querySelector('[id^="VideoMedia-Poster-"]').offsetWidth + 'px';
      const content = document.createElement('div');
      content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
      this.setAttribute('loaded', true);
      const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
    }
  }
}
customElements.define('video-media', VideoMedia);




/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
  return function() {
    return fn.apply(scope, arguments);
  }
};

Shopify.setSelectorByValue = function(selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function(target, eventName, callback) {
  target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for(var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
  this.countryEl         = document.getElementById(country_domid);
  this.provinceEl        = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);
  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function() {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function() {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function(e) {
    var opt       = this.countryEl.options[this.countryEl.selectedIndex];
    var raw       = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function(selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function(selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  }
};
